module.exports = __webpack_public_path__ + "img/reward.ebe5a60b.svg";